import { useUserStore } from '@/shared/store/useUserStore';
import {
  useRouter,
  useRoute,
} from '@intlify/vue-router-bridge';

export function useHasActiveCardGuard() {
  const router = useRouter();
  const route = useRoute();
  const userStore = useUserStore();

  if (route.name === 'GetCard' && userStore.hasActivePhysicalUserCard) {
    router.replace({ name: 'Profile' });
  }
}
